import { CodelistResponse } from '../../../../api/models'
import { CombinedNomenclatureOption } from './useCommodityCodeSearch'

export const DIGIT_OR_WHITESPACE = /^[\d\s]{0,10}$/

export type CommodityCodeOption = {
  value: string
  label: string
  codeLabel: string
  isArchived: boolean
}

export function mapToOptions(content: CodelistResponse[], country: string | null, isEns: boolean): CombinedNomenclatureOption[] {
  return content
    .filter((item) => {
      if (country !== 'BG' || (country === 'BG' && isEns)) {
        return true
      }

      const codeLabelLength = item.codeLabel?.replace(/\s/g, '')?.length ?? 0

      return codeLabelLength <= 6
    })
    .map<CombinedNomenclatureOption>((codelistItem) => ({
    value: codelistItem.code ?? '',
    codeLabel: codelistItem.codeLabel ?? '',
    name: codelistItem.nameEn ?? '',
    isArchived: codelistItem.isArchived ?? false,
  }))
}
